export const VIEW = "VIEW";
export const ADVANCE_SEARCH = "ADVANCE_SEARCH";
export const DELETE = "DELETE";
export const APPROVE_USERS = "APPROVE_USERS";
export const DELEGATE_USERS = "DELEGATE_USERS";
export const APPROVE_STUDENTS = "APPROVE_STUDENTS";
export const VIEW_STUDENT_HISTORY = "VIEW_STUDENT_HISTORY";
export const MANAGE_CATALOG = "MANAGE_CATALOG";
export const MANAGE_ORDER = "MANAGE_ORDER";
export const VIEW_STUDENTS = "VIEW_STUDENTS";
export const MANAGE_LOANS = "MANAGE_CATALOG";
export const VIEW_TEXTBOOKS = "VIEW_TEXTBOOKS";
export const VIEW_APH = "VIEW_APH";
export const MANAGE_APH_LOANS = "MANAGE_APH_LOANS";
export const MANAGE_APH_CATALOG_ITEMS = "MANAGE_APH_CATALOG_ITEMS";
export const VIEW_LOAN_LIBRARY = "VIEW_LOAN_LIBRARY";
export const MANAGE_LOAN_LIBRARY_CATALOG = "MANAGE_LOAN_LIBRARY_CATALOG";
export const MANAGE_LOAN_LIBRARY_LOANS = "MANAGE_LOAN_LIBRARY_LOANS";
export const VIEW_BRAILLER = "VIEW_BRAILLER";
export const MANAGE_BRAILLER_CATALOG = "MANAGE_BRAILLER_CATALOG";

